<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'empty'" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="full hr mg0" v-show="!editMode">
          <div class="sortArea">
            <div class="lcont">
              <span class="txtM">
                총
                <em>{{ totalCnt }}</em>
                건
              </span>
            </div>
            <div class="rcont">
              <button type="button" class="btn_s s" @click="editMode = true"><span>편집</span></button>
            </div>
          </div>
        </section>

        <section class="full hr mg0" v-show="editMode">
          <div class="sortArea">
            <div class="lcont">
              <span class="singleIpt">
                <input type="checkbox" class="ipt" name="mod_hr_1" id="mod_hr_1" v-model="chkAll" />
                <label for="mod_hr_1">전체선택</label>
              </span>
            </div>
            <div class="rcont">
              <button type="button" class="btn_s s" @click="editMode = false"><span>취소</span></button>
              <button type="button" class="btn_s s" @click="deletePrdHistory"><span>선택삭제</span></button>
            </div>
          </div>
        </section>

        <section class="hr mb30" v-show="prdListLength != null && prdListLength > 0">
          <ul class="prdList">
            <li v-for="(value, key) in prdList" :key="key">
              <!-- 편집 버튼 클릭시 -->
              <span class="singleIpt" v-show="editMode">
                <input type="checkbox" class="ipt" name="prdBox" :id="'mod_hr_1_' + key" v-model="chkSub" :value="value.productIndex" />

                <label :for="'mod_hr_1_' + key">
                  <span class="blind">해당열 상품</span>
                  선택
                </label>
              </span>
              <button type="button" class="delBtn" v-show="editMode" @click="deletePrdHistory(value.productIndex)">
                <span class="blind">해당열 상품 삭제</span>
              </button>

              <div class="block">
                <div class="prdItem full">
                  <div class="imgArea">
                    <div class="badgeArea">
                      <span class="badge" v-for="(tag, key) in value.tagInfos.topTags" :key="key"><img :src="tag.imgPath" /></span>
                    </div>
                    <a class="img imgCover" @click="goDetail(value.productIndex)">
                      <img :src="value.thumbnail" :alt="value.displayName" />
                    </a>
                  </div>
                  <div class="infoArea">
                    <a class="tit row2" @click="goDetail(value.productIndex)">
                      <span>{{ value.displayName }}</span>
                    </a>
                    <div class="txtItem">
                      <span>{{ value.model }}</span>
                    </div>
                    <div class="hashtag" v-if="value.tagInfos.bottomTags.length > 0">
                      <span v-for="(tag, key) in value.tagInfos.bottomTags" :key="key">{{ tag.tagName }}</span>
                    </div>
                    <div class="price">
                      <span class="money del">
                        월
                        <span>{{ value.rentalAmount | currency }}</span>
                        원
                      </span>
                      <br />
                      <span class="money pointC1">
                        월
                        <em>{{ value.cardDCrentalAmount | currency }}</em>
                        원
                        <i>/제휴카드가</i>
                      </span>
                    </div>

                    <ul class="utilBtn">
                      <li>
                        <a class="icoBtn zzim" @click="updateWishList(value)" :class="{ on: value.wishItem }">
                          <span>
                            찜 (
                            <i>{{ value.wishCount | currency }}</i>
                            )
                          </span>
                        </a>
                        <!-- 클래스 on -->
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </section>

        <!-- 조회결과가 없을 시 -->
        <section class="hr mb30" v-show="prdListLength != null && prdListLength < 1">
          <div class="resultMsg txtOnly">
            <p class="copy">최근 본 상품이 없습니다.</p>
          </div>
        </section>

        <CommonBanner></CommonBanner>
        <UpdateWishList ref="wish" @updateWishCount="updateWishCount"></UpdateWishList>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->

    <ConfirmPop v-if="confirmPop" @cancel="cancel" @confirm="confirm" @close="close">
      <p v-html="msg"></p>
    </ConfirmPop>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
    <QuickMenu :clear="clear"></QuickMenu>

    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import UpdateWishList from '@/components/comm/UpdateWishList';
import ConfirmPop from '@/components/popup/ConfirmPop';
import CommonBanner from '@/components/banner/CommonBanner';
import QuickMenu from '@/views/app/comm/QuickMenu';
import MessagePop from '@/components/popup/MessagePop';
export default {
  name: 'productHistory',
  components: {
    UpdateWishList,
    ConfirmPop,
    CommonBanner,
    QuickMenu,
    MessagePop,
  },
  mounted() {
    this.getPrdHistory();
    this.getBanner();
  },
  data: function() {
    return {
      headerTitle: '최근본상품',

      prdList: [],
      prdListLength: null,
      bannerList: [],
      totalCnt: 0,
      chkAll: false, // 전체동의
      chkSub: [], // 필수, 선택 동의 여부
      target: null,
      editMode: false,
      prdHis: [],
      confirmPop: false,
      msg: '',
      messagePop: false,
      clear: false,
    };
  },
  watch: {
    chkAll() {
      this.chkSub = [];
      if (this.chkAll) {
        const array_termsSub = document.getElementsByName('prdBox');
        for (let i = 0; i < array_termsSub.length; i++) {
          this.chkSub.push(array_termsSub[i].value);
        }
      }
    },
    editMode() {
      if (!this.editMode) {
        this.chkAll = false;
        this.chkSub = [];
      }
    },
  },
  methods: {
    goDetail: function(idx) {
      this.$router.push('/product/category/detail/' + idx);
    },
    getPrdHistory: function() {
      this.chkAll = false;
      this.editMode = false;
      let obj = window.localStorage.getItem('prdHistory');
      this.prdHis = JSON.parse(obj);

      if (this.prdHis == null) this.prdHis = [];

      if (this.prdHis.length < 1) {
        this.prdList = [];
        this.prdListLength = 0;
        this.totalCnt = 0;
      } else {
        this.$refs.header.loadingStart();

        let param = JSON.stringify(this.prdHis.reverse()).replace(/[\\[\]\\"\s]/gi, '');
        ApiService.service('GET', '/product/recent/' + param)
          .then(({ data }) => {
            this.prdList = data.result;
            this.prdListLength = data.result.length;
            this.totalCnt = data.result.length;
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
            this.categoryPrdList = [];
          })
          .finally(() => {
            this.$refs.header.loadingEnd();
          });
      }
    },
    getBanner: function() {
      ApiService.service('GET', 'resource/banner/27')
        .then(({ data }) => {
          this.bannerList = data.result[0].bannerDtos;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    deletePrdHistory: function(idx) {
      if (typeof idx == 'object' && this.chkSub.length < 1) {
        this.msg = '삭제할 상품을 선택해주세요.';
        this.messagePop = true;
        return false;
      }
      this.msg = '최근본 상품을<br>삭제 하시겠습니까?';
      this.confirmPop = true;
      if (typeof idx == 'object') {
        this.target = {};
      } else {
        this.target = idx;
      }
    },
    deletePrdHistoryProc: function(list) {
      console.log(list);
      for (let i = 0; i < list.length; i++) {
        this.prdHis = this.prdHis.filter(item => item !== list[i].toString());
      }

      window.localStorage.setItem('prdHistory', JSON.stringify(this.prdHis));
      this.getPrdHistory();
      window.scrollTo(0, 0);
      if (this.prdHis.length == 0) this.clear = true;
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      this.confirmPop2 = false;
      this.bottomPop = false;
      this.noticePop = false;
      this.webViewPop = false;
      this.sharePop = false;
      this.findAddr = false;
      this.optionPop = false;
      this.couponPop = false;
    },
    cancel() {
      this.confirmPop = false;
      this.confirmPop2 = false;
    },
    confirm() {
      this.confirmPop = false;
      let d = Array();
      if (typeof this.target == 'object') {
        this.chkSub.forEach(key => d.push(new String(key)));
      } else {
        d.push(this.target);
        //this.deletePrdHistoryProc(this.target);
      }
      this.deletePrdHistoryProc(d);
    },
    updateWishList(product) {
      this.$refs.wish.updateWishList(product);
    },
    updateWishCount(product, flag, count) {
      product.wishItem = flag;
      product.wishCount += count;
    },
  },
};
</script>
